import { FC, useEffect, useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid, Paper, useMediaQuery, useTheme } from '@material-ui/core';
import CommonTable from 'containers/CommonTable';
import TableHeader from 'components/Headers/TableHeader';
import { useStyles } from './styles';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import { useHistory } from 'react-router-dom';
import { useStore } from 'hooks/useRootStore';
import BusinessIcon from '@material-ui/icons/Business';
import { handleCompanyUrl } from 'utils/organizationUtils';

const Departments: FC = observer(() => {
  const {
    ldapStore: {
      setDepartmensKeywordFilter,
      clearClickedDepartment,
      departmentsView,
      getDepartments,
      getDepartment,
      setClickedDepartment,
      deleteDepartment,
      // getSync,
      // syncs,
      syncDepartment,
    },
  } = useStore();
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const profile = JSON.parse(localStorage.getItem('Profile') as string);
  const userId = profile?.id;
  const getData =
    profile?.permission === 'EndUser'
      ? () => getDepartment(userId)
      : profile?.permission === 'Manager' && !profile?.managed?.includes('departments')
      ? () => getDepartment(userId)
      : profile?.permission === 'Manager'
      ? () => getDepartments()
      : () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
  const [loading, setLoading] = useState(false);
  const [departmentsLoaded, setDepartmentsLoaded] = useState(false);
  const isFetching = useRef(false);

  useEffect(() => {
    const shouldLoadSpecificDepartment =
      profile?.permission === 'Manager' && !profile?.managed?.includes('departments');
    const shouldLoadAllDepartments = profile?.permission !== 'EndUser' && profile?.permission !== 'Manager';

    if (shouldLoadSpecificDepartment && !departmentsLoaded && !isFetching.current && userId) {
      setLoading(true);
      isFetching.current = true;
      getDepartment(userId)
        .then((response) => {
          setDepartmentsLoaded(true);
        })
        .catch((error) => {
          setDepartmentsLoaded(true);
        })
        .finally(() => {
          setLoading(false);
          isFetching.current = false;
        });
    } else if (
      Array.isArray(departmentsView) &&
      departmentsView.length === 0 &&
      shouldLoadAllDepartments &&
      !departmentsLoaded &&
      !isFetching.current
    ) {
      setLoading(true);
      isFetching.current = true;
      getDepartments()
        .then((response) => {
          if (response?.data?.length > 0) {
            setDepartmentsLoaded(true);
          }
        })
        .catch(() => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
          isFetching.current = false;
        });
    }
  }, [
    departmentsLoaded,
    departmentsView.length,
    departmentsView,
    profile?.permission,
    profile?.managed,
    getDepartments,
    getDepartment,
    userId,
  ]);

  useEffect(() => {
    if (history.action === 'POP') {
      localStorage.removeItem('CurrentDepartment');
    }
    if (history.action === 'PUSH' && departmentsLoaded) {
      setLoading(true);
      getDepartments().finally(() => setLoading(false));
    }
    document.title = 'EasyIdentity: Departments';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid item xs={12}>
      <Container
        maxWidth={isMobile ? false : 'xl'}
        className={classes.container}
        style={isMobile ? { padding: '8px' } : {}}
      >
        <Grid className={classes.infoContainer} container alignItems='stretch' justify='flex-end'>
          <TableHeader
            headerLabel='Departments'
            headerAction={() => {
              localStorage.removeItem('CurrentDepartment');
              history.push(handleCompanyUrl('/department/add'));
            }}
            headerChecked={true}
            headerIcon={<BusinessOutlinedIcon style={{ color: 'grey' }} />}
            searchAction={setDepartmensKeywordFilter}
            hanleClicked={clearClickedDepartment}
          />
        </Grid>
      </Container>
      <Container
        maxWidth={isMobile ? false : 'xl'}
        className={classes.tableBox}
        style={isMobile ? { padding: '4px' } : {}}
      >
        <Paper className={classes.paper}>
          <CommonTable
            getData={getData}
            dataHeadName='DEPARTMENT'
            dataName='ou'
            dataValue='delete'
            dataLabel='List of Assigned Departments'
            deleteLabel='Are you sure you want to delete this department? Because you will lose all the users associated with this department. Type delete to confirm.'
            deleteData={deleteDepartment}
            syncData={syncDepartment}
            fieldtable='Department'
            view={departmentsView}
            clickedData={setClickedDepartment}
            tableIcon={<BusinessIcon style={{ color: 'grey' }} />}
            viewTable={() => history.push(handleCompanyUrl('/department/users'))}
            editTable={() => history.push(handleCompanyUrl('/department/edit'))}
            user={profile?.permission}
            loading={loading}
          />
        </Paper>
      </Container>
    </Grid>
  );
});

export default Departments;
